import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgLocked = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M20.66 9.34H18V6.67C18 3.24 15.57 0 12 0a6.32 6.32 0 0 0-6 6.63v2.71H3.34A1.3 1.3 0 0 0 2 10.6v.1s.05 11.23 0 12A1.28 1.28 0 0 0 3.25 24a.14.14 0 0 0 .09 0h17.32A1.32 1.32 0 0 0 22 22.66v-12a1.33 1.33 0 0 0-1.34-1.32M7.34 6.67a4.68 4.68 0 1 1 9.32-.86 4 4 0 0 1 0 .86v2.67H7.34Zm5.19 11.09 1 3.12h-3.45l1-3.13h.09a2.61 2.61 0 0 1-2-2.51 2.69 2.69 0 0 1 5.38 0 2.61 2.61 0 0 1-2.02 2.52"
    }));
export default SvgLocked;
